import { Link } from "react-router-dom";

interface CTAProps {
  to: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "ghost-light";
  size?: "md" | "lg";
  block?: boolean;
  style?: React.CSSProperties;
}

export function CTA({ to, children, variant = "primary", size = "md", block, style }: CTAProps) {
  const cls = [
    "btn",
    `btn-${variant}`,
    size === "lg" ? "btn-lg" : "",
    block ? "btn-block" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Link to={to} className={cls} style={style}>
      {children}
    </Link>
  );
}
